import React, { useEffect, useState } from 'react';
import {
  Grid,
  Dropdown,
  DropdownItemProps,
  Input,
  Icon,
  Button,
  TextArea,
  Checkbox,
  Table,
  Message
} from 'semantic-ui-react';
import { FormikProps } from 'formik';
import { FieldLabel } from '../../../../../../styles';
import { SyntheticEvent } from 'react-router/node_modules/@types/react';
import {
  CancellationInsurancePolicyProps,
  cancellationReasonOptions,
  RelatedPolicy
} from '../../../../types';
import { CancellationInitialValues } from '../../Formik/initialStatesCancel';
import _ from 'lodash';
import {
  dangerNotification,
  warningNotification,
  successNotification
} from '../../../../../../services/notification';
import FileUploader, {
  fileTypeProps
} from '../../../../../../components/UploadFilesUncontroled';
import { get } from '../../../../../../services/storage';
import { isValidEmail } from '../../../../../../utils/emailValidator';
import {
  cancelAlfaSegurosProposal,
  cancelGeralProposal,
  cancelPortoSeguroProposal
} from '../../../../../../services/fire-insurance-proposal';
import { InsurersCodeEnum } from '../../../../../../enums/insurers-code.enum';
import * as S from './styles';

const fileIdentifiers: fileTypeProps[] = [
  { name: 'Outros', key: 'OTHER', required: false },
  {
    name: 'Termo compra do imóvel',
    key: 'PROPERTY_PURCHASE_TERM'
  },
  {
    name: 'Termo de antecipação de locação',
    key: 'LEASE_ADVANCE_TERM'
  },
  {
    name: 'Termo de desistência de locação',
    key: 'LEASE_WITHDRAWL_TERM'
  },
  {
    name: 'Termo de Entrega de Chaves com Inexistência de débitos',
    key: 'DELIVERY_KEYS_TERM'
  },
  {
    name: 'Termo de troca de locatário',
    key: 'TENANT_CHANGE_TERM'
  },
  {
    name: 'Termo cancelamento de troca de seguradora',
    key: 'INSURANCE_CHANGE_TERM'
  },
  {
    name: 'Termo cancelamento duplicidade de apólice',
    key: 'DUPLICATION_POLICY_TERM'
  },
  {
    name: 'Termo cancelamento troca de garantia',
    key: 'CHANGE_WARRANTY_TERM'
  },
  { name: 'Termo de rescisão', key: 'TERMINATION_TERM' },
  {
    name: 'Endosso de cancelamento',
    key: 'CANCELATION_ENDORSEMENT'
  },
  {
    name: 'Comprovante de pagamento',
    key: 'PAYMENT_VOUCHER'
  }
];

const CancellationInsuranceForm = ({
  values,
  setFieldValue,
  flagSubmit,
  callbackSubmit,
  setFlagSubmit,
  hiredDataId,
  relatedPolicies,
  onFirePoliciesSelected
}: FormikProps<typeof CancellationInitialValues> & CancellationInsurancePolicyProps) => {
  const [reasonsOptions, setReasonsOptions] = useState<Array<DropdownItemProps>>([]);
  const [selectedFirePolicies, setSelectedFirePolicies] = useState<string[]>([]);
  const [isLoadingFirePolicies, setIsLoadingFirePolicies] = useState<boolean>(false);

  const userId = get('uid');

  useEffect(() => {
    setReasonsOptions(cancellationReasonOptions);
  }, []);

  const handleFirePolicySelection = (policyId: string) => {
    let updatedSelection;
    if (selectedFirePolicies.includes(policyId)) {
      updatedSelection = selectedFirePolicies.filter(id => id !== policyId);
    } else {
      updatedSelection = [...selectedFirePolicies, policyId];
    }

    setSelectedFirePolicies(updatedSelection);

    if (onFirePoliciesSelected) {
      onFirePoliciesSelected(updatedSelection);
    }
  };

  useEffect(() => {
    function submitForm() {
      let error = false;
      setFlagSubmit && setFlagSubmit(false);

      if (!values.cancellationReason) {
        warningNotification('Ops...', 'Por favor, preencha o motivo da locação!');
        error = true;
      }

      if (!values.policyFiles || values.policyFiles.length === 0) {
        warningNotification('Ops...', 'Por favor, anexe pelo menos um arquivo!');
        error = true;
      }

      if (!values.notificationEmails || values.notificationEmails.length === 0) {
        warningNotification(
          'Ops...',
          'Por favor, preencha pelo menos um e-mail para notificação!'
        );
        error = true;
      }

      if (values.notificationEmails) {
        values.notificationEmails.forEach(email => {
          if (!isValidEmail(email)) {
            warningNotification('Ops...', `O e-mail ${email} não é válido!`);
            error = true;
          }
        });
      }

      if (error) {
        return;
      }

      const payload = {
        hiredDataId,
        userId: userId,
        cancellationReason: values.cancellationReason,
        observations: values.observations,
        notificationEmails: values.notificationEmails,
        files: values.policyFiles
      };

      callbackSubmit(payload);
    }
    flagSubmit && submitForm();
  }, [flagSubmit]);

  return (
    <div>
      <Grid columns="equal">
        <Grid.Row>
          <Grid.Column width={8}>
            <FieldLabel>
              Motivo do cancelamento <span className="required">*</span>
            </FieldLabel>
            <Dropdown
              name={`bondInsurance.reason`}
              value={values.cancellationReason}
              options={reasonsOptions}
              onChange={(e, { value }) => setFieldValue('cancellationReason', value)}
              floating
              search
              selection
              fluid
              placeholder="Selecione"
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <FieldLabel>
              E-mails para notificação <span className="required">*</span>
            </FieldLabel>
            <S.EmailsContainer>
              {(values?.notificationEmails as string[]).map(
                (notificationEmail, index) => {
                  return (
                    <S.EmailRow key={index}>
                      <Input
                        value={notificationEmail}
                        placeholder="Digite..."
                        onChange={(e: any, { value }: { value: string }) => {
                          setFieldValue(`notificationEmails[${index}]`, value);
                        }}
                        onBlur={() => {
                          if (notificationEmail && !isValidEmail(notificationEmail)) {
                            warningNotification(
                              'Ops...',
                              'Por favor, preencha um e-mail válido!'
                            );
                          }
                        }}
                      />
                      <Icon
                        name={'remove circle'}
                        color={'red'}
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                        size={'large'}
                        onClick={() => {
                          if (values.notificationEmails?.length === 1) {
                            setFieldValue(`notificationEmails`, ['']);
                          } else {
                            const arr1 = values.notificationEmails?.slice(0, index);
                            const arr2 = values.notificationEmails?.slice(index + 1);
                            const newArr = [...(arr1 as string[]), ...(arr2 as string[])];
                            setFieldValue(`notificationEmails`, newArr);
                          }
                        }}
                      />
                    </S.EmailRow>
                  );
                }
              )}
              <Button
                size="small"
                icon
                labelPosition="left"
                onClick={() => {
                  if (values.notificationEmails?.length) {
                    const lastEmail =
                      values.notificationEmails[values.notificationEmails.length - 1];
                    if (lastEmail.length > 0)
                      setFieldValue(`notificationEmails`, [
                        ...(values.notificationEmails as string[]),
                        ''
                      ]);
                  } else {
                    setFieldValue(`notificationEmails[0]`, '');
                  }
                }}
              >
                <Icon name="plus" />
                Adicionar E-mail
              </Button>
            </S.EmailsContainer>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={{ paddingTop: '0', marginTop: '0' }}>
          <Grid.Column width={16}>
            <FieldLabel>Observações</FieldLabel>
            <S.ObservationsContainer>
              <TextArea
                name={`bondInsurance.observations`}
                rows={3}
                value={values.observations}
                onChange={(_: SyntheticEvent, data: any) => {
                  setFieldValue(`observations`, data.value);
                }}
              />
            </S.ObservationsContainer>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <S.FilesSection>
        <FieldLabel>Envio de arquivos</FieldLabel>
        <S.FilesDescription>
          Para solicitar o cancelamento da Apólice é <strong>OBRIGATÓRIO</strong> anexar
          pelo menos um dos seguintes arquivos:
        </S.FilesDescription>
        <S.Hr />
        <S.FilesList>
          <div className="file-list-column">
            <div className="file-item">
              • Termo cancelamento compra do imóvel. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+compra+do+im%C3%B3vel.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Termo cancelamento de desistência de locação. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+de+desist%C3%AAncia+de+loca%C3%A7%C3%A3o.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Termo cancelamento de entrega de chaves e inexistência de débitos. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+de+entrega+de+chaves+e+inexist%C3%AAncia+de+d%C3%A9bitos.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Termo cancelamento de troca de locatário. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+de+troca+de+locat%C3%A1rio.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Termo cancelamento de troca de seguradora. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+de+troca+de+seguradora.docx">
                Baixar Modelo
              </a>
              )
            </div>
          </div>
          <div className="file-list-column">
            <div className="file-item">
              • Termo cancelamento duplicidade de apólice. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+duplicidade+de+ap%C3%B3lice.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Termo cancelamento troca de garantia. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+cancelamento+troca+de+garantia.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Termo de inexistência de débitos. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Termo+de+inexistencia+de+debitos.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">
              • Distrato locador imobiliária e inexistência de débitos. (
              <a href="https://4seg-documents-analysis.s3.amazonaws.com/Modelos+Cancelamento/Distrato+locador+imobiliaria+e+inexistencia+de+debitos.docx">
                Baixar Modelo
              </a>
              )
            </div>
            <div className="file-item">• Termo de recisão.</div>
          </div>
        </S.FilesList>

        <FileUploader
          fileIdentifiers={fileIdentifiers}
          files={values.policyFiles}
          setFieldValue={setFieldValue}
          fieldName={'policyFiles'}
        />
      </S.FilesSection>

      {relatedPolicies && relatedPolicies.length > 0 && (
        <S.FilesSection>
          <FieldLabel>Deseja cancelar seguros de incêndio relacionados?</FieldLabel>
          <div style={{ margin: '10px 0', display: 'flex', gap: '20px' }}>
            <Checkbox
              radio
              label="Não"
              checked={!selectedFirePolicies.length}
              onChange={() => setSelectedFirePolicies([])}
            />
            <Checkbox
              radio
              label="Sim"
              checked={selectedFirePolicies.length > 0}
              onChange={() => {
                if (selectedFirePolicies.length === 0 && relatedPolicies.length > 0) {
                  setSelectedFirePolicies([relatedPolicies[0].id]);
                }
              }}
            />
          </div>

          {selectedFirePolicies.length > 0 && (
            <>
              <Message info>
                <Message.Header>Cancelamento de seguros de incêndio</Message.Header>
                <p>
                  Selecione os seguros de incêndio que deseja cancelar junto com o seguro
                  fiança. Estes seguros estão relacionados ao mesmo inquilino e endereço.
                </p>
              </Message>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Selecionar</Table.HeaderCell>
                    <Table.HeaderCell>Criado em</Table.HeaderCell>
                    <Table.HeaderCell>Seguradora</Table.HeaderCell>
                    <Table.HeaderCell>Imobiliária</Table.HeaderCell>
                    <Table.HeaderCell>Endereço</Table.HeaderCell>
                    <Table.HeaderCell>Vigência</Table.HeaderCell>
                    <Table.HeaderCell>Prêmio total</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {relatedPolicies.map(policy => (
                    <Table.Row key={policy.id}>
                      <Table.Cell collapsing>
                        <Checkbox
                          checked={selectedFirePolicies.includes(policy.id)}
                          onChange={() => handleFirePolicySelection(policy.id)}
                          disabled={isLoadingFirePolicies}
                        />
                      </Table.Cell>
                      <Table.Cell>{policy.createdAt}</Table.Cell>
                      <Table.Cell>{policy.insurerName}</Table.Cell>
                      <Table.Cell>{policy.estateName}</Table.Cell>
                      <Table.Cell>{policy.address}</Table.Cell>
                      <Table.Cell>
                        {policy.validity.startDate}
                        <br />
                        {policy.validity.endDate}
                      </Table.Cell>
                      <Table.Cell>
                        R$ {policy.totalPremium.value.toFixed(2)}
                        <br />({policy.totalPremium.installments}x) R${' '}
                        {policy.totalPremium.installmentValue.toFixed(2)}
                      </Table.Cell>
                      <Table.Cell>{policy.status}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </>
          )}
        </S.FilesSection>
      )}
    </div>
  );
};
export default CancellationInsuranceForm;
